export const config = {
  title: "K.L.J Quality Construction LLC | Ambridge, PA",
  meta: {
    description:
      "K.L.J Quality Construction LLC has proudly served Ambridge, PA since 2010. Providing quality construction, professional painting, deep cleaning, and roofing services. Free estimates and flexible payment options.",
    keywords: [
      "K.L.J Quality Construction LLC",
      "General Contractor Ambridge PA",
      "Construction Services Pennsylvania",
      "Professional Painting",
      "Roofing Services",
      "Deep Cleaning Services",
      "Home Remodeling",
      "Commercial Construction",
      "Residential Construction"
    ],
    author: "K.L.J Quality Construction LLC",
    canonicalUrl: "https://kljqualityconstructionllc.com/",
  },
  sections: {
    header: {
      businessName: "K.L.J Quality Construction LLC",
    },
    sectionB: {
      heroTitle: "Comprehensive Property Services with Exceptional Results",
      heroSubtitle: "Your Trusted Construction Partner Since 2010 - Serving Ambridge, PA",
      learnAboutText: "Get Free Estimate",
      phoneNumber: "7249204152",
      phoneLabel: "(724) 920-4152",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2076&auto=format&fit=crop",
      cardData: [
        {
          title: "General Construction",
          description:
            "From new builds and remodeling to repairs and restorations—complete construction services for your property.",
        },
        {
          title: "Professional Painting",
          description:
            "Transform any space with expert interior and exterior painting that adds value and character.",
        },
        {
          title: "Roofing Services",
          description:
            "Your roof's first line of defense—professional installation, repair, and maintenance services.",
        },
      ],
      description:
        "K.L.J Quality Construction LLC has proudly served homes and businesses across Ambridge, PA since 2010, providing dependable and high-quality construction and property services with exceptional craftsmanship.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Your all-in-one solution for property improvement and maintenance. We handle every step—from construction and repairs to finishing touches and post-project cleaning.",
      cards: [
        {
          title: "General Construction",
          description:
            "Complete construction services covering new builds, home remodeling, repairs, and restorations with expert craftsmanship and premium materials.",
          imageSrc: "https://images.unsplash.com/photo-1581094271901-8022df4466f9?q=80&w=2070&auto=format&fit=crop",
          imageAlt: "General Construction Services",
        },
        {
          title: "Professional Painting",
          description:
            "Expert interior and exterior painting services that transform spaces with precise brushwork, perfect paint lines, and lasting beauty.",
          imageSrc: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?q=80&w=2074&auto=format&fit=crop",
          imageAlt: "Professional Painting Services",
        },
        {
          title: "Roofing Services",
          description:
            "Professional roofing installation, repair, and maintenance to protect your property with durable, seamless installations.",
          imageSrc: "https://media.istockphoto.com/id/979361764/photo/general-contractor-installing-new-roof.jpg?s=612x612&w=0&k=20&c=Anw4gkVeqBuH09r4-AWpg9m9YPxZxtk8pZKInzL0XPU=",
          imageAlt: "Roofing Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Deep Cleaning Services",
        "Home Remodeling",
        "Commercial Construction",
        "Property Maintenance",
        "Restoration Services",
      ],
    },
    sectionD: {
      aboutTitle: "About K.L.J Quality Construction LLC",
      aboutImage: {
        src: "https://storage.googleapis.com/msgsndr/BvdBP645b4vw8GVEnebS/media/68ed7d319c7177fe13d5e687.webp",
        alt: "K.L.J Quality Construction Team",
      },
      aboutText: [
        "For over a decade, K.L.J Quality Construction LLC has built a strong reputation founded on honesty, precision, and consistent results. Since 2010, we've proudly served homes and businesses across Ambridge, PA and within a 50-mile radius, providing dependable and high-quality construction and property services.",
        "Our clients appreciate our commitment to professionalism, clear communication, and dependable service. We treat every home and business with care and respect, ensuring projects are completed efficiently and to the highest standards. Our experienced team uses premium materials, proven tools, and safe methods to deliver durable, precise, and aesthetically pleasing results that consistently exceed expectations.",
      ],
    },
    sectionE: {
      profileImage: "https://assets.cdn.filesafe.space/BvdBP645b4vw8GVEnebS/media/68ed7ac66d717dd6273b3d98.png",
      profileAlt: "K.L.J Quality Construction LLC",
      businessName: "K.L.J Quality Construction LLC",
      contact: {
        phone: "7249204152",
        phoneLabel: "(724) 920-4152",
        email: "info@kljqualityconstructionllc.com",
        website: "https://kljqualityconstructionllc.com/",
        address: "1020 Rice Ave, Ambridge, PA 15003",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "1020 Rice Ave, Ambridge, PA 15003",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3034.8!2d-80.2256!3d40.5889!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88349e8e8e8e8e8e%3A0x8e8e8e8e8e8e8e8e!2s1020%20Rice%20Ave%2C%20Ambridge%2C%20PA%2015003!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;